const DefaultPlaceholder = () => (
  <p className="text-gray-500">
    <span className="text-black">Upload invoice</span> — click to select or drug&drop
  </p>
);

export default DefaultPlaceholder;
